import React from 'react';

import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '@/queryClient';
import { DataCacheProvider } from '@/contexts/cache';
import { AppContextProvider } from '@/contexts/app';
import { FormContextProvider } from '@/contexts/form';
import { UserContextProvider } from '@/contexts/user';
import { KeycloakProvider } from '@/contexts/keycloak';
import { LanguageContextProvider } from '@/contexts/language';
import { AnalyticsContextProvider } from '@/contexts/analytics';

import { App } from '../App';
import SessionErrorForwarder from './SessionErrorForwarder';

export default function Index() {
  return (
    <DataCacheProvider>
      <AppContextProvider>
        <FormContextProvider>
          <AnalyticsContextProvider>
            <UserContextProvider>
              <KeycloakProvider>
                <LanguageContextProvider>
                  <QueryClientProvider client={queryClient}>
                    <SessionErrorForwarder />
                    <App />
                  </QueryClientProvider>
                </LanguageContextProvider>
              </KeycloakProvider>
            </UserContextProvider>
          </AnalyticsContextProvider>
        </FormContextProvider>
      </AppContextProvider>
    </DataCacheProvider>
  );
}
